import { render, staticRenderFns } from "./StudentHasDebtTable.vue?vue&type=template&id=5214fc80&"
import script from "./StudentHasDebtTable.vue?vue&type=script&lang=js&"
export * from "./StudentHasDebtTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports